import axios from 'axios';

export const signup = async (input: Record<string, any>): Promise<any> => {
  const response = await axios.post('/api/register', input);
  return response?.data;
};

export default signup;
